import React from 'react';
import moment from 'moment';
import { OrderNote } from '../../../models/OrderNote';
import { Card, Header, CreatedAt, CreatedBy, Body } from './styles';

interface ICardOrderNoteProps {
    note?: OrderNote;
}

const CardOrderNote: React.FC<ICardOrderNoteProps> = ({
    note
}) => {

    return (
        <Card>
            <Header>
                <CreatedAt>
                    {moment(note?.createdAt).format('DD/MM/yyyy HH:mm:ss')}
                </CreatedAt>
                <CreatedBy>
                    {note?.createdBy?.name}
                </CreatedBy>
            </Header>
            <Body>
                {note?.value}
            </Body>
        </Card>
    );
}

export {CardOrderNote};